import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.mizar = bracketIndenting({
	line: "::",
})
